export default __webpack_public_path__ + "static/Deployment-to-Upgrades-db39e7db403987613199b0e24454231d.webp";